import React, { FC, useEffect, useState } from 'react';
import {
	IconButton,
	InputAdornment,
	StandardTextFieldProps,
	TextField,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { INPUT_TYPES } from './form.utils';
import { FormField } from '../../lib/interfaces/Form';

interface InputTextFieldProps extends StandardTextFieldProps {
	fieldInputType?: string;
	isAdditionalButtonClicked?: boolean;
	showOnAdditionalBtnClicked?: boolean;
	field: FormField;
	formValues: any;
	handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const InputTextField: FC<any> = ({
	fieldInputType,
	isAdditionalButtonClicked,
	formValues,
	field,
	handleChange,
	...props
}: InputTextFieldProps) => {
	const [showPassword, setShowPassword] = useState(false);
	const [value, setValue] = useState(formValues[field.name] || '');

	const onTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setValue(event.target.value);
		handleChange(event);
	};

	useEffect(() => {
		setValue(formValues[field.name]);
	}, [formValues[field.name]]);

	const isPasswordField = fieldInputType === INPUT_TYPES.PASSWORD;

	if (props.showOnAdditionalBtnClicked && !isAdditionalButtonClicked && !value) {
		return null;
	}

	return isPasswordField ? (
		<TextField
			{...props}
			onChange={onTextChange}
			type={showPassword ? 'text' : 'password'}
			value={value}
			InputProps={{
				endAdornment: (
					<InputAdornment position="end">
						<IconButton
							aria-label="toggle password visibility"
							onClick={() => setShowPassword(!showPassword)}
						>
							{showPassword ? <Visibility /> : <VisibilityOff />}
						</IconButton>
					</InputAdornment>
				),
			}}
		/>
	) : (
		<TextField {...props} onChange={onTextChange} value={value} />
	);
};

export default InputTextField;
